export default "__VITE_ASSET__w35dgzlu__"